import { FunctionComponent } from "react";
import { Box } from "../../box";
import styles from "./empty-state.module.scss";
import { Stack, Icon, Text } from "@edgetier/global-components";
import { IProps } from "./empty-state.types";

/**
 * A pre-built empty state component with a dotted background pattern and centred content.
 * @param {IconDefinition} props.icon - The icon to display in the empty state.
 * @param {string} props.title - The title of the empty state.
 * @param {string} props.description - The description of the empty state.
 * @param {number|string} props.size - The size of the empty state. Will overwrite other props if aren't passed.
 * @param {number|string} props.height - The height of the empty state.
 * @param {number|string} props.width - The width of the empty state.
 * @returns {JSX.Element} The EmptyState component.
 */
export const EmptyState: FunctionComponent<IProps> = ({ icon, title, description, height, width, size = 500 }) => {
    return (
        <Stack className={styles["empty-state"]} h={height ?? size} w={width ?? size}>
            <Box className={styles["dot-background"]} />
            <Stack gap="md" className={styles["content"]}>
                <Icon icon={icon} size="xl" color="gray" />
                {title && (
                    <Text variant="semibold" size="lg">
                        {title}
                    </Text>
                )}
                {description && (
                    <Text dimmed variant="medium" size="md" ta="center">
                        {description}
                    </Text>
                )}
            </Stack>
        </Stack>
    );
};
